<ng-select
  appendTo="body"
  [items]="adminList$ | async"
  [formControl]="formControl"
  bindLabel="firstName"
  [searchFn]="customSearchFn"
>
  <ng-template ng-label-tmp let-item="item">
    {{ renderMe(item) }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ renderMe(item) }}
  </ng-template>
</ng-select>
